import React from "react";

// Chakra imports
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

const vdhLogo = `${process.env.PUBLIC_URL}/vdh-logo.svg`;

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <Flex align='center' my='28px' gap='10px'>
        <Image src={vdhLogo} alt='Vui Để Học' w='36px' h='36px' borderRadius='10px' />
        <Text fontSize='20px' fontWeight='800' letterSpacing='-0.5px' color={logoColor}>
          Vui Để Học
        </Text>
      </Flex>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
